import { createCrudSlice } from '@crm/features/crudSliceFactory';

const module = createCrudSlice({
  name: 'crmGoods',
  path: 'goods',
  singleKey: 'goods',
});

export const goodsActions = module.actions;
export const goodsThunks = module.thunks;
export const goodsSelectors = module.selectors;
export default module.reducer;
